import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '../../../../generic-components/Heading';

interface IProps {
    checkData: {details: string, mailingAddress: string, estimatedArrivalMessage: string};
}

export const CheckDetails = ({ checkData }: IProps) => {
  const { t } = useTranslation();
  return (
    <div className='flex flex-col gap-[14px]'>
      <div className='flex items-start justify-between w-full'>
        <Heading title={t('MAIL_CHECK_TRANSACTIONS_DETAILS.STATUS')} className='text-[14px] text-bw07 font-metricR leading-[145%]' />
        <Heading title={checkData?.details || ''} className='text-[14px] text-bw08 font-metricRSemibold' />
      </div>
      <div className='flex items-start justify-between w-full'>
        <Heading title={t('MAIL_CHECK_TRANSACTIONS_DETAILS.ADDRESS')} className='basis-1/2 text-[14px] text-bw07 font-metricR leading-[145%]' />
        <Heading title={checkData?.mailingAddress || ''} className='basis-1/2 break-words text-end text-[14px] text-bw08 font-metricRSemibold' />
      </div>

      <div className='flex items-start justify-between w-full'>
        <Heading title={t('MAIL_CHECK_TRANSACTIONS_DETAILS.DATE')} className='basis-1/2 text-[14px] text-bw07 font-metricR leading-[145%]' />
        <Heading title={checkData?.estimatedArrivalMessage || ''} className='basis-1/2 break-words text-end text-[14px] text-bw08 font-metricRSemibold' />
      </div>
    </div>
  );
};
